import Base from "./Base";
import store from "../storeWire";
import { DataAssets, loadData, removeAll } from "../store/slice/model/ProductCompare";

class ProductCompare extends Base {
    products = {};

    setData(data) {
        store.dispatch(loadData({
            data: data.data
        }));
    }

    setDataAssets(data) {
        store.dispatch(DataAssets({
            products: data.products,
            products_inventory: data.products_inventory,
            products_pricing: data.products_pricing
        }));
    }

    removeAll() {
        store.dispatch(removeAll());
    }
}

export default ProductCompare;